import { ToggleGroup } from "radix-ui";
import type { ReactNode } from "react";
import { cn } from "./cn";

export function Segmented<T extends string>({
  value,
  onChange,
  options,
  className,
  size = "sm",
}: {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: ReactNode; title?: string }[];
  className?: string;
  size?: "sm" | "xs";
}) {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v as T)}
      className={cn("inline-flex rounded-md border border-line bg-panel p-0.5", className)}
    >
      {options.map((o) => (
        <ToggleGroup.Item
          key={o.value}
          value={o.value}
          title={o.title}
          className={cn(
            "rounded px-2 text-muted transition-colors hover:text-fg data-[state=on]:bg-raised data-[state=on]:text-fg data-[state=on]:shadow-sm",
            size === "sm" ? "h-6 text-xs" : "h-5 text-[11px]",
          )}
        >
          {o.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}
